module.exports = __webpack_public_path__ + "9c9ab698e43542ea11f3c9dcf2f05953.pdf";